module.exports = __webpack_public_path__ + "static/img/icon-5.d707dea5.png";